import { Company } from '../../../types/models/company/company.types';
import { COMPANY_ENDPOINTS } from '../../../utils/api/endpoints/companyEndpoints';

const PREFIX = '[companyNAFQuery]';

export const queryCompanyNAF = async () => {
  console.log(PREFIX, `Fetching company infos...`);
  const response = await COMPANY_ENDPOINTS.currentNAF();

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received company infos.`);
  return json as Company & { domains: [number, string][] };
};
